<template>
  <div class="closed-end-of-month card-box">
    <div class="remaining-variables container-padding">
      <div class="updated-to">מעודכן ל-{{ updateTime }}</div>
      <div class="title">{{ formattedTitle }}</div>
      <div class="top-of-mind-metric" :class="{ positive: isMonthBalancePositive, zero: isMonthBalanceEven, negative: isMonthBalanceNegative }">
        {{ formattedTotal }} ₪ {{ numberPrefix }}
      </div>
    </div>
    <div class="divider"></div>
    <div class="total-amounts">
      <div class="total-amounts-row">
        <div>סה"כ הכנסות</div>
        <div class="amount" :class="{ positive: isMonthBalancePositive }">{{ formattedTotalIncome }} ₪ + </div>
      </div>
      <div class="total-amounts-row">
        <div>סה"כ הוצאות</div>
        <div class="amount" :class="{ negative: isMonthBalanceNegative }">{{ formattedTotalExpense }} ₪ - </div>
      </div>
    </div>
    <balance-vs-cashflow-button/>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

import BalanceVsCashflowButton from './BalanceVsCashflowButton.vue';
import moneyUtils from '../../../../../../../../utils/money';

export default {
  name: 'ClosedEndOfMonth',
  components: {
    BalanceVsCashflowButton,
  },
  computed: {
    ...mapGetters('cashflowView', ['monthName', 'balance', 'budgetUpdatedAt', 'totalIncome', 'totalExpense']),
    formattedTitle() {
      if (this.isMonthBalanceNegative) {
        return `${this.monthName} הסתיים בתזרים שלילי של:`;
      }
      return `מעולה! ${this.monthName} הסתיים בתזרים חיובי של:`;
    },
    updateTime() {
      const updateHour = moment(this.budgetUpdatedAt).format('H:mm');
      const updateDate = moment(this.budgetUpdatedAt).format('D.M.YY');
      return `${updateHour}, ${updateDate}`;
    },
    numberPrefix() {
      if (this.isMonthBalanceNegative) {
        return '- ';
      }
      return '';
    },
    formattedTotal() {
      return moneyUtils.formatAmountWithFraction(this.balance, 0);
    },
    formattedTotalIncome() {
      return moneyUtils.formatAmountWithFraction(this.totalIncome, 0);
    },
    formattedTotalExpense() {
      return moneyUtils.formatAmountWithFraction(this.totalExpense, 0);
    },
    isMonthBalancePositive() {
      return this.balance > 0;
    },
    isMonthBalanceEven() {
      return this.balance === 0;
    },
    isMonthBalanceNegative() {
      return this.balance < 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .closed-end-of-month {
    margin-bottom: 11px;

    .container-padding {
      padding: 7px 18px ;
    }

    .remaining-variables {
      padding-top: 17px;
    }

    .updated-to {
      color: $riseup_gray_2;
      font-size: 10px;
    }

    .title {
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      line-height: 1.00em;
      margin: 4px 0 32px;
    }

    .top-of-mind-metric {
      font-family: SimplerPro;
      font-size: 46px;
      line-height: 32px;
      margin: 0 0 18px;
      font-weight: bold;

      &.positive {
        color: $riseup_green;
      }
      &.zero {
        color: $riseup_black;
      }
      &.negative {
        color: $riseup_coral;
      }
    }

    .divider {
      height: 1px;
      width: 100%;
      background-color: $riseup_gray_0;
    }

    .total-amounts {
      padding: 10px 19px 9px 23px;
      line-height: 23px;
      display: flex;
      justify-content: space-between;

      .amount {
        font-weight: bold;

        &.positive {
          color: $riseup_green;
        }

        &.negative {
          color: $riseup_coral;
        }
      }
    }
  }
</style>
